import { REQUIRED_INDICATOR_CLASS_NAME } from '../../components/baseV2';
import { FORTA_GRAY1, FORTA_GRAY2, FORTA_WHITE } from '../../utils/colors';

import type { SxProps, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

// Give read-only fields a muted fill and a not-allowed cursor so they read as
// non-editable rather than looking identical to an active input.
export const READ_ONLY_FIELD_SX: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': { backgroundColor: FORTA_GRAY1 },
  '& .MuiInputBase-input': { cursor: 'not-allowed' },
};

export const FORM_FIELD_TOP_LABEL_SX: SxProps<Theme> = {
  display: 'block',
  fontWeight: 500,
  textAlign: 'left',
  mb: 0.5,
};

export const FORM_FIELD_BOTTOM_LABEL_SX: SxProps<Theme> = {
  display: 'block',
  fontWeight: 500,
  textAlign: 'left',
  mt: 0.5,
};

// Number fields share the arrow-less style that centers its text; override it
// back to left so numeric inputs align like the other form fields.
export const NUMBER_FIELD_LEFT_ALIGN_SX: SxProps<Theme> = {
  '& .MuiOutlinedInput-input': { textAlign: 'left' },
};

// White boxed lists; the Required caption takes the same fill to mask the field border.
export const LIST_CONTAINER_SX: SystemStyleObject<Theme> = {
  bgcolor: FORTA_WHITE,
  boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.25)',
  [`& .${REQUIRED_INDICATOR_CLASS_NAME}`]: { bgcolor: FORTA_WHITE },
};

// Alternating row fills shared by auto-save and selection lists (and field chrome that sits on them).
export const LIST_ROW_BG_COLORS = ['#F2F8FF', '#F9FDFF'] as const;

export const LIST_ROW_BG_SX = [
  { bgcolor: LIST_ROW_BG_COLORS[0] },
  { bgcolor: LIST_ROW_BG_COLORS[1] },
];

export const LIST_ROW_BORDER_SX = {
  border: `1px solid ${FORTA_GRAY2}`,
};
